import React from "react";

const Layout = props => <div className="App">{props.children}</div>;

export default React.memo(Layout);
